// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"332":"c2691966","418":"5761d4e9"}[chunkId] + ".js";
};